// safetyFormLists/safetyAuditList/state.js

import { filtersInitialState } from "../../shared/filters/filtersState";

export const safetyAuditListInitialState = {
  items: [],
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  error: null,
  needsUpdate: false,
  selectedSafetyAudit: null,
  filters: filtersInitialState({ status: "Draft" }),
};
